import React from "react";
import { useRegistrationContext } from "../../Contexts/RegistrationContext";
import { AccordionItem } from "../../Elements/Accordion";
import { DrawType } from "../../Map/enums";
import { DrawingButton } from "./DrawingButton";
import { SketchProps } from "./SketchProps";

export const DrawPoints = (): JSX.Element => {
    const { drawnFeatures } = useRegistrationContext();

    const noteFeatures = drawnFeatures.filter(
        (f) => f.getGeometry().getType() === "Point" && f.get("DESCRIPTION") !== undefined
    );
    const buttons = [{ type: DrawType.Point, icon: "icon-conexus-shovel" }];

    return (
        <AccordionItem
            title="Darbu vieta (punkts)"
            defaultExpanded={Date.now()}
            changeHeight={Date.now()}
            key="Darbu vieta (punkts)"
        >
            <div className="triangle-top"></div>
            <div className="draw-toolbar">
                {buttons.map((b) => (
                    <DrawingButton iconClass={b.icon} type={b.type} key={b.type + b.icon}></DrawingButton>
                ))}
            </div>
            {noteFeatures &&
                noteFeatures.map((f) => <SketchProps feature={f} key={f.get("TEMPID") + "note"}></SketchProps>)}
        </AccordionItem>
    );
};
